const TwIntro = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 17.12 13.92' {...props}>
    <path d='M15.37 3.47v.45a9.93 9.93 0 0 1-10 10 10 10 0 0 1-5.37-1.58 7.58 7.58 0 0 0 .84.05 7 7 0 0 0 4.36-1.51 3.49 3.49 0 0 1-3.28-2.44 2.84 2.84 0 0 0 .66.07 3.1 3.1 0 0 0 .92-.13 3.5 3.5 0 0 1-2.81-3.44v-.05a3.29 3.29 0 0 0 1.59.44 3.52 3.52 0 0 1-1.57-2.92 3.55 3.55 0 0 1 .48-1.77 9.93 9.93 0 0 0 7.24 3.67 3.44 3.44 0 0 1-.09-.8 3.52 3.52 0 0 1 6.08-2.4 7.16 7.16 0 0 0 2.23-.85 3.48 3.48 0 0 1-1.55 1.94 6.78 6.78 0 0 0 2-.55 7.21 7.21 0 0 1-1.75 1.82z' />
  </svg>
)

export default TwIntro



// WEBPACK FOOTER //
// ./components/icons/tw-intro.js